var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFemale = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "-279 396.8 35.7 49.1",
    enableBackground: "new -279 396.8 35.7 49.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M-243.3,425.4c0,0.7-0.3,1.4-0.8,1.9s-1.2,0.8-1.9,0.8c-0.9,0-1.7-0.4-2.2-1.2l-6.3-9.5h-1.3v3.7l6.9,11.5 c0.2,0.3,0.3,0.6,0.3,0.9c0,0.5-0.2,0.9-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5h-5.4v7.5c0,0.9-0.3,1.6-0.9,2.2c-0.6,0.6-1.3,0.9-2.2,0.9 h-4.5c-0.9,0-1.6-0.3-2.2-0.9s-0.9-1.3-0.9-2.2v-7.6h-5.4c-0.5,0-0.9-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.3-0.9 l6.9-11.5v-3.7h-1.3l-6.3,9.5c-0.5,0.8-1.3,1.2-2.2,1.2c-0.7,0-1.4-0.3-1.9-0.8s-0.8-1.1-0.8-1.8c0-0.5,0.1-1,0.4-1.5l7.1-10.7 c1.4-2,3-3,4.9-3h10.7c1.9,0,3.6,1,4.9,3l7.1,10.7C-243.4,424.3-243.3,424.8-243.3,425.4z M-256.7,398.6c1.2,1.2,1.8,2.7,1.8,4.4 c0,1.7-0.6,3.2-1.8,4.4c-1.2,1.2-2.7,1.8-4.4,1.8c-1.7,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.8-2.7-1.8-4.4c0-1.7,0.6-3.2,1.8-4.4 s2.6-1.8,4.4-1.8C-259.4,396.8-257.9,397.4-256.7,398.6z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFemale, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/female.bf9d199b.svg";
export { ForwardRef as ReactComponent };